import Axios from "axios";
import type { IApiConnector } from "@frui.ts/apiclient";
import { FetchApiConnector } from "@frui.ts/apiclient";

Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const content = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(error.response.data) as any));
    return Promise.reject({ ...error, content });
  }
);

// @TODO Přijít na to proč je jinak soubor poškozený
export default class AxiosApiConnector extends FetchApiConnector implements IApiConnector {
  post(url: string, body?: BodyInit, params?: RequestInit): Promise<Response> {
    return this.checkAxiosUsageForPost(url.split("?")[0])
      ? Axios.post(url, body, { method: "POST", responseType: "arraybuffer", headers: params?.headers as Record<string, string> })
      : super.post(url, body, params);
  }

  get(url: string, params?: RequestInit): Promise<Response> {
    return this.checkAxiosUsageForGet(url.split("?")[0])
      ? Axios.get(url, { method: "GET", responseType: "arraybuffer", headers: params?.headers as Record<string, string> })
      : super.get(url, params);
  }

  checkAxiosUsageForPost(url: string) {
    return (
      url.includes("bulk_exemptions") ||
      url.includes("bulk_exemption_cancellations") ||
      url.includes("charge_order_cancellations") ||
      url.includes("charges_order_differences") ||
      url.includes("outgoing_paygate_payments/report") ||
      url.includes("outgoing_transfer_payments/report") ||
      url.includes("outgoing_paygate_reversal_payments/report") ||
      url.includes("monthly_expenses/report") ||
      url.includes("monthly_revenues/report")
    );
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  checkAxiosUsageForGet(url: string) {
    if (url.match(/call_center\/distributors\/.+\/payment_request_reports$/g)) {
      return true;
    }

    if (url.match(/call_center\/charges\/.+\/anonymized_receipt$/g)) {
      return true;
    }

    if (url.match(/enforcement\/lustration_reports\/.+\/report$/g)) {
      return true;
    }

    if (url.match(/accounting\/account_balance_check_requests\/.+\/result_file$/g)) {
      return true;
    }

    if (url.match(/accounting\/documents_inventories\/.+\/check_result_file$/g)) {
      return true;
    }

    if (url.match(/accounting\/documents_inventories\/.+\/account_files\/.+$/g)) {
      return true;
    }

    if (
      !(url.includes("finance") || (url.includes("reports") && !url.endsWith("reports"))) ||
      !(url.includes("report") || url.includes("templates") || url.includes("file"))
    ) {
      return false;
    }

    return (
      (url.includes("external_reports") && url.endsWith("/report")) ||
      (url.includes("internal_reports") && url.endsWith("/report")) ||
      url.includes("transfer_refund_exports") ||
      url.includes("paygate_refund_exports") ||
      url.includes("internal_transfer_exports") ||
      url.includes("distributor_refund_exports") ||
      url.includes("outgoing_transfer_payments") ||
      url.includes("outgoing_paygate_payments") ||
      url.includes("monthly_turnovers") ||
      url.includes("accounting/templates") ||
      url.includes("unreturned_refunds_of_refunds/report") ||
      (url.includes("sub_ledger_reports") && url.endsWith("/file"))
    );
  }
}
